import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Login from './containers/login';
import OrderBook from './containers/order-book';
import Inventory from './containers/inventory';
import Vendor from './containers/vendor';
import Vehicles from './containers/vehicles';
import Routing from './containers/routing';
import RoutingMap from './containers/routing-map';
import FarmOrders from './containers/farm-orders';
import FarmTransport from './containers/farm-transport';
import FarmRouting from './containers/farm-routing';
import FarmConfiguration from './containers/farm-configuration';
import FarmTransportVehicles from './containers/farm-transport-vehicles';
import FarmDashboard from './containers/farm-dashoard';
import FarmDivision from './containers/farm-division';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  }, {
    path: "/order-book",
    element: <OrderBook />,
  }, {
    path: "/inventory",
    element: <Inventory />,
  }, {
    path: "/vendors",
    element: <Vendor />,
  }, {
    path: "/vehicles/:id",
    element: <Vehicles />,
  }, {
    path: "/routing",
    element: <Routing />,
  }, {
    path: "/routing-map",
    element: <RoutingMap />,
  }, {
    path: "/farm-dashboard",
    element: <FarmDashboard />
  }, {
    path: "/farm-orders",
    element: <FarmOrders />,
  }, {
    path: "/farm-transport",
    element: <FarmTransport />,
  }, {
    path: "/farm-routing",
    element: <FarmRouting />,
  }, {
    path: "/farm-configuration",
    element: <FarmConfiguration />,
  }, {
    path: "/farm-transport/:id",
    element: <FarmTransportVehicles />,
  }, {
    path: "/farm-division",
    element: <FarmDivision />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
